function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M10.5445 5.09906C11.3565 4.46749 11.8742 4.06765 12.2979 3.81232C12.691 3.57547 12.8749 3.54484 13.0002 3.54484C13.1256 3.54484 13.3094 3.57547 13.7025 3.81232C14.1263 4.06765 14.644 4.46749 15.456 5.09906L24.1816 11.8857L25.8188 9.78074L17.0348 2.94869C16.2983 2.37583 15.655 1.87545 15.0788 1.52823C14.4567 1.15339 13.7898 0.878174 13.0002 0.878174C12.2106 0.878174 11.5438 1.15339 10.9217 1.52823C10.3454 1.87545 9.70215 2.37583 8.96571 2.94868L0.181641 9.78074L1.81882 11.8857L10.5445 5.09906Z",
  fill: "#262BBA"
});
var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M11.6673 12.8332H9.00065V10.1665H11.6673V12.8332Z",
  fill: "#262BBA"
});
var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M17.0007 12.8332H14.334V10.1665H17.0007V12.8332Z",
  fill: "#262BBA"
});
var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M11.6673 22.1665V30.1665H9.00065V21.4998C9.00065 20.3953 9.89608 19.4998 11.0007 19.4998H15.0007C16.1052 19.4998 17.0007 20.3953 17.0007 21.4998V30.1665H14.334V22.1665H11.6673Z",
  fill: "#262BBA"
});
var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M3.66732 24.8332V22.1665H6.33398V24.8332H3.66732Z",
  fill: "#262BBA"
});
var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M19.6673 22.1665V24.8332H22.334V22.1665H19.6673Z",
  fill: "#262BBA"
});
function SvgIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 31,
    viewBox: "0 0 26 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon);
export default __webpack_public_path__ + "static/media/icon.300a8a9ae2de59cbaea7d87ec5a26f54.svg";
export { ForwardRef as ReactComponent };